<template>
  <div>
    <el-table :data="currencyList">
      <el-table-column prop="symbol" label="币种"></el-table-column>
      <el-table-column prop="name" label="名称"></el-table-column>
      <el-table-column prop="createTime" label="时间">
        <template slot-scope="scope">
            {{scope.row.createTime | moment}}
        </template>
              </el-table-column>
              <el-table-column prop="__status" label="状态">
        <template slot-scope="scope">
          <el-tag :type="scope.row.__status.color">
            {{scope.row.__status.text}}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
      label="操作" fixed="right" width="150">
        <template slot-scope="scope" >
          <el-button v-if="scope.row.status === 0" size="mini" type="primary" @click="bindCurrency(scope.row.id)">接入MyToken</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
export default {
  name: 'MyTokenCurrencyList',
  computed: {
    ...mapGetters('myTokenCurrency', ['currencyList'])
  },
  methods: {
    ...mapActions('myTokenCurrency', ['bind']),
    bindCurrency(id) {
      this.bind(id).then(() => {
        this.$message.success('设置成功！');
        this.$emit('refresh');
      });
    }
  }
};
</script>

<style lang="less" scoped>
</style>
